import Flex, { type FlexProps } from "@ui-kit/layout/Flex/Flex.web";

/**
 * A wrapper that formats the width of certain assigned seating page content:
 * The seating cart and the navbar content directly above it.
 *
 * On mobile screen sizes or when the event doesn't have a refund policy,
 * The navbar section containing the refund policy should be hidden.
 *
 * On mobile screen sizes, the seating page cart should be hidden.
 */
export default function SeatingSideWrapper({ children, ...props }: FlexProps) {
  return (
    <Flex
      display={{ base: "none", sm: "flex" }}
      w={{ base: "0", sm: "element.16xl" }}
      flexShrink={0}
      minHeight="0"
      {...props}
    >
      {children}
    </Flex>
  );
}
